import { render, staticRenderFns } from "./uploadPublic.vue?vue&type=template&id=8e51e0c0&scoped=true"
import script from "./uploadPublic.vue?vue&type=script&lang=js"
export * from "./uploadPublic.vue?vue&type=script&lang=js"
import style0 from "./uploadPublic.vue?vue&type=style&index=0&id=8e51e0c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e51e0c0",
  null
  
)

export default component.exports